import React, { Component } from "react"
import DataAccessRequestListItem from "./DataAccessRequestListItem"
import PaginationButtons from "../../../../reuseable-components/PaginationButtons";


class DataAccessRequestList extends Component {

  render() {
    const {
      getRequests,
      requests,
      numberOfPages,
      currentPage,
      buttonsPerPage,
      activeTab,
      handleRequestActions
    } = this.props

    if (requests.length) {
      return (
        <div>
          <center>
            <PaginationButtons
              onClick={ getRequests }
              numberOfPages={ numberOfPages }
              currentPage={ currentPage }
              buttonsPerPage={ buttonsPerPage }
            />
          </center>
          <div className="data-access-request-table-container">
            <table className="data-access-request-table" style={ activeTab === "approved" ? { width: "100vw" } : null }>
              <thead>
                <tr className="data-access-request-table-head">
                  <th>Data Source</th>
                  <th>User</th>
                  <th>Client</th>
                  <th>Created Date</th>
                  { activeTab === "approved" ?
                    <React.Fragment>
                      <th>Approved Date</th>
                      <th>Expiration Date</th>
                      <th>Expiring In</th>
                    </React.Fragment>
                    :
                    <th>Actions</th>
                  }
                </tr>
              </thead>
              <tbody>
                { requests.map(request => (
                  <DataAccessRequestListItem
                    activeTab={ activeTab }
                    key={ request.id }
                    request={ request }
                    handleRequestActions={ handleRequestActions }
                  />
                )) }
              </tbody>
            </table>
          </div>
        </div>
      )
    } else {
      return (
        <center>
          <h5>There are no requests that are matching current filters...</h5>
        </center>
      )
    }

  }
}

export default DataAccessRequestList


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequestManager/components/DataAccessRequestList.js